import { get } from "scriptjs";
import { Logger } from "./Logger.js";
import { ProxyUrl } from "./ProxyUrl.js";
import { SharedContext } from "./SharedContext.js";

let _importCache = new Map();
const importModule = (url, aliasList) => {
  return new Promise((resolve, reject) => {
    let aliasRequiresLoading = [];
    let cachedModule = _importCache.get(url);
    if (cachedModule) {
      for (const alias of aliasList) {
        const mod = cachedModule[alias];
        if (!mod) {
          aliasRequiresLoading.push(alias);
        } else {
          SharedContext.set(alias, mod);
        }
      }
    } else {
      cachedModule = {};
      aliasRequiresLoading = aliasList;
    }

    if (aliasRequiresLoading.length == 0) {
      resolve();
      return;
    }

    if (typeof window.module === "undefined") {
      window.module = { exports: { skip: true } };
    }

    try {
      get(url, async () => {
        for (const alias of aliasRequiresLoading) {
          const newModule =
            window[alias] || globalThis[alias] || window.module.exports;
          if (newModule instanceof Promise) {
            try {
              const asyncModuleResult = await newModule;
              SharedContext.set(alias, asyncModuleResult);
              cachedModule[alias] = asyncModuleResult;
              resolve();
            } catch (error) {
              // console.log(error)
            }
          } else if (newModule && !newModule.skip) {
            SharedContext.set(alias, newModule);
            cachedModule[alias] = newModule;
            resolve();
          } else {
            reject(
              new Error(
                `Failed to import URL ${url}: The URL does not exist or the symbol [${alias}] is not defined`
              )
            );
          }
        }
        _importCache.set(url, cachedModule);
        window.module.exports = { skip: true };
      });
    } catch (err) {
      reject(new Error(`Failed to import URL ${url}`));
    }
  });
};

/**
 *  Import and expose the modules in the global context for the scripting api.
 */
export const dynamicImport = async (url, aliasList) => {
  try {
    // Use scriptjs to dynamically load the script
    await importModule(ProxyUrl.getProxiedUrl(url), aliasList);
  } catch (error) {
    Logger.error("Error importing module ->", error);
  }
};
